<template>
  <div class="palette-overlay" :class="{open: open}" @click.self="close">
    <div class="palette">
      <input
        ref="input"
        class="palette-input"
        type="text"
        placeholder="Search courses, tests, pages…"
        v-model="query"
      />
      <div class="palette-results">
        <div v-for="(sec, si) in sections" :key="si">
          <div class="palette-section-label">{{ sec.label }}</div>
          <div
            v-for="(item, ii) in sec.items"
            :key="ii"
            class="palette-item"
            @click="pick(item)"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            <div>
              <div class="palette-item-title">{{ item.title }}</div>
              <div class="palette-item-sub">{{ item.sub }}</div>
            </div>
            <span v-if="item.kbd" class="palette-item-kbd">G {{ item.kbd }}</span>
          </div>
        </div>
        <div v-if="!sections.length" style="padding:36px 20px;text-align:center;color:var(--muted);font-size:13px;">
          No results for "{{ query }}"
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ALL_ITEMS = [
  { section:'Pages',    title:'Dashboard',      sub:'Your activity overview',  route:'/dashboard',             kbd:'D' },
  { section:'Pages',    title:'Catalog',        sub:'Browse all tests',        route:'/catalog',               kbd:'C' },
  { section:'Pages',    title:'My Tests',       sub:'Tests in progress',       route:'/my-tests',              kbd:'T' },
  { section:'Pages',    title:'Results & Badges', sub:'Past attempts',         route:'/results',               kbd:'R' },
  { section:'Pages',    title:'Keys',           sub:'License keys',            route:'/keys',                  kbd:'K' },
  { section:'Products', title:'Authoring Tool', sub:'Build assessments',       route:'/authoring' },
  { section:'Products', title:'Partner Portal', sub:'Org administration',      route:'/partner' },
  { section:'Products', title:'Assessment',     sub:'Talent assessment',       route:'/italentup/home' },
  { section:'Developer',title:'API Reference',  sub:'REST API v2',             route:'/developer/api' },
  { section:'Developer',title:'Webhooks',       sub:'Event subscriptions',     route:'/developer/webhooks' },
  { section:'Developer',title:'LTI Connections',sub:'LMS integrations',        route:'/partner/content/lti' },
  { section:'Account',  title:'Profile',        sub:'Your account',            route:'/account/profile' },
  { section:'Account',  title:'Billing',        sub:'Invoices & payment',      route:'/account/billing' },
];

export default {
  name: 'CommandPalette',
  data() { return { query: '' }; },
  computed: {
    open() { return this.$store.state.ui.commandPaletteOpen; },
    sections() {
      const q = this.query.toLowerCase();
      const filtered = ALL_ITEMS.filter(i =>
        i.title.toLowerCase().includes(q) || i.sub.toLowerCase().includes(q)
      );
      const map = {};
      filtered.forEach(item => {
        (map[item.section] = map[item.section] || []).push(item);
      });
      return Object.entries(map).map(([label, items]) => ({ label, items }));
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.query = '';
        this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
      }
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKey);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
  },
  methods: {
    close() { this.$store.commit('SET_PALETTE', false); },
    onKey(e) {
      if (e.key === 'Escape') this.close();
    },
    pick(item) {
      this.close();
      if (item.route) this.$router.push(item.route).catch(() => {});
    },
  },
};
</script>
